import React, { useEffect, useState } from "react";
import PopupDialog from "../../../../shared/components/PopupScreen/Dialog";
import { Box, Typography } from "@mui/material";
import TextAreaInput from "../../../../shared/components/TextAreaInput";
import TagInput from "../../../../shared/components/tags/Tags";
import TextInput from "../../../../shared/components/TextInput";
import { createStyles, makeStyles } from "@mui/styles";
import {
  ButtonPrimary,
  ButtonSecondary,
} from "../../../../shared/components/button/Buttons";
import { updateMultipleComponents } from "../../../../services/component";
import { getAllCollections } from "../../../../services/collection";
import { toastError, toastSuccess } from "../../../../utils/ToastMessage";
import Dropdown from "../../../../shared/components/Dropdown";
import { getAllCategories } from "../../../../services/category";
import DropdownMultiSelect from "../../../../shared/components/DropdownMultiSelect/DropdownMultiSelect";
import { useGlobalContext } from "../../../../App";

interface EditMultipleComponentsProps {
  selectedRows: Array<string>;
  setEditMultipleComponentsDialogueVisible: any;
  setActiveSelectedMenu: any;
  setProductList: any;
  setSelectedRows: any;
}

const EditMulipleComponentsDialogue = (props: EditMultipleComponentsProps) => {
  const styles = useStyles();
  const {
    selectedRows,
    setEditMultipleComponentsDialogueVisible,
    setActiveSelectedMenu,
    setProductList,
    setSelectedRows,
  } = props;

  const { typographyOptionsList } = useGlobalContext();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [tags, setTags] = useState([]);
  const [blurb, setBlurb] = useState("");
  const [collection, setCollection] = useState({ id: "", name: "" });
  const [category, setCategory] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [status, setStatus] = useState("");
  const [license, setLicense] = useState("");
  const [theme, setTheme] = useState("");
  const [typography, setTypography] = useState([]);
  const [categoriesFetchOptions, setCategoriesFetchOptions] = useState<
    Record<string, any>[]
  >([]);
  const [collectionsFetchOptions, setCollectionsFetchOptions] = useState<
    Record<string, any>[]
  >([]);

  useEffect(() => {
    const fetchCategories = async (filters?: any) => {
      await getAllCategories(filters)
        .then((res: any) => {
          setCategoriesFetchOptions(res.paginatedConstantValues);
        })
        .catch((err: any) => {
          console.log(err);
        });
    };

    const fetchCollections = async (filters?: any) => {
      await getAllCollections(filters)
        .then((res: any) => {
          setCollectionsFetchOptions(res.paginatedCollections);
          // console.log(res.paginatedCollections);
        })
        .catch((err: any) => {
          console.log(err);
        });
    };

    fetchCategories({ type: "COMPONENT_CATEGORY" });
    fetchCollections({ type: "COMPONENT" });
  }, []);

  //This function is to add link in typography if it is selected because it only send name and id in dropdown multiselect

  const returnTypographyArray = (
    selectedArray: {
      name: string;
      id: string;
    }[]
  ) => {
    const result = [];

    for (let selected of selectedArray) {
      for (let options of typographyOptionsList) {
        if (options.id === selected.id) {
          result.push({ ...selected, link: options?.link });
        }
      }
    }
    return result;
  };

  const handleSaveEditMultipleComponents = async () => {
    const typographyArray = returnTypographyArray(typography);

    const data = {
      ids: selectedRows,
      title,
      description,
      blurb,
      tags,
      collectionId: collection.id,
      collectionName: collection.name,
      categoryId,
      category,
      license,
      status,
      theme,
      typography: typographyArray,
    };

    await updateMultipleComponents(data)
      .then((res: any) => {
        toastSuccess("Success", "Successfully updated Multiple components");
        setEditMultipleComponentsDialogueVisible(false);
        setActiveSelectedMenu(false);
        // setProductList(res?.data);
        setSelectedRows([]);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
      .catch((err) => {
        toastError("Error", "There is some error updating component.");
      });
  };

  return (
    <PopupDialog
      style={{
        width: "948px !important",
        maxHeight: "fit-content",
        height: "100%",
        overflow: "hidden !important",
        display: "flex",
        // gap: "36px",
        justifyContent: "center",
        backgroundColor: "#1B1B1B",
        background: "#1B1B1B",
        boxShadow: "inset 0px 0px 0px 1px #3D3D3D",
        padding: "0px",
        position: "relative",
      }}
      open={true}
      //   title="Edit"
      //   titleStyle={{
      //     color: "white",
      //   }}
      onClose={() => {
        props?.setEditMultipleComponentsDialogueVisible(false);
      }}
      title="Edit Multiple Components"
      titleStyle={{
        color: "#FFFFFF",
        fontSize: "24px",
        fontWeight: "600",
        lineHeight: "28px",
        marginLeft: "24px",
        marginTop: "24px",
      }}
      iconStyle={{
        position: "absolute",
        right: "24px",
        top: "24px",
      }}
      children={
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            bgcolor: "#1B1B1B",
            borderRadius: "14px",
            padding: "36px 24px 24px 24px",
            gap: "24px",
          }}
        >
          {/* Row1 */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              gap: "40px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                gap: "24px",
              }}
            >
              <Box sx={{ flex: 1 }} className={styles.inputContainer}>
                <TextInput
                  style={{ flex: 1 }}
                  label="Title"
                  lableStyles={{ fontSize: "16px !important" }}
                  placeholder="Enter the title"
                  type="text"
                  value={title}
                  onChange={(e: any) => {
                    setTitle(e.target.value);
                  }}
                />

                <Typography
                  className="err_field"
                  id="createProductTitlebNotExist"
                  color="red"
                  variant="body2"
                ></Typography>
              </Box>
              <Box>
                <Dropdown
                  label="Categories"
                  className={styles.dropdown}
                  classDropdownLabel={styles.label}
                  classDropdownPlaceholder={styles.placeholder}
                  classDropdownValueText={styles.dropdownValueText}
                  dropdownOptionsBodyStyles={{
                    fontWeight: "300",
                    fontSize: "16px",
                  }}
                  dropdownBodyStyles={{
                    width: "100%",
                  }}
                  value={category}
                  placeholder="Select"
                  // setValue={(value: any) => {
                  //   console.log("value", value);
                  //   setCategory(value[0]?.title);
                  //   setCategoryId(value[0]?.id);
                  // }}
                  setValue={(value: any) => {
                    console.log("value", value);
                    // If it's the same, unselect it
                    if (value[0]?.title === category) {
                      setCategory("");
                      setCategoryId("");
                      return;
                    }
                    setCategory(value[0]?.title);
                    setCategoryId(value[0]?.id);
                  }}
                  options={categoriesFetchOptions.map((option) => ({
                    title: option.value,
                    id: option._id,
                  }))}
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <Dropdown
                  label="License"
                  className={styles.dropdown}
                  classDropdownLabel={styles.label}
                  classDropdownPlaceholder={styles.placeholder}
                  classDropdownValueText={styles.dropdownValueText}
                  dropdownOptionsBodyStyles={{
                    fontWeight: "300",
                    fontSize: "16px",
                  }}
                  dropdownBodyStyles={{
                    width: "100%",
                  }}
                  value={license}
                  placeholder="Select"
                  setValue={(value: any) => {
                    // If it's the same, unselect it
                    if (value === license) {
                      setLicense("");
                      return;
                    }
                    setLicense(value);
                  }}
                  options={["FREE", "PREMIUM"]}
                />
              </Box>
              <Box>
                <DropdownMultiSelect
                  label="Typography"
                  searchBoxStyles={{
                    backgroundColor: "#292929",
                    color: "#FFFFFF",
                    padding: "12px 12px 12px 16px",
                  }}
                  optionsBodyStyles={{ backgroundColor: "#292929" }}
                  className={styles.dropdown}
                  classDropdownLabel={styles.label}
                  classDropdownHead={styles.classDropdownHead}
                  classSelectedValueStyles={styles.classSelectedValueStyles}
                  classDropdownOption={styles.classDropdownOption}
                  classChipContainerStyle={styles.classChipContainerStyle}
                  classDropdownBody={styles.classDropdownBody}
                  value={typography || []}
                  placeholder="Select"
                  setValue={(selected: any) => {
                    setTypography(selected);
                  }}
                  selectedOptionColor="#FFFFFF !important"
                  optionsDefaultColor="#8B8B8B"
                  optionsList={typographyOptionsList}
                />
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                gap: "24px",
              }}
            >
              <Box sx={{ flex: 1 }} className={styles.inputContainer}>
                <TextInput
                  style={{ flex: 1 }}
                  label="Blurb"
                  lableStyles={{ fontSize: "16px !important" }}
                  placeholder="Short product description"
                  type="text"
                  value={blurb}
                  onChange={(e: any) => {
                    setBlurb(e.target.value);
                  }}
                />

                <Typography
                  className="err_field"
                  id="createProductBlurbNotExist"
                  color="red"
                  variant="body2"
                ></Typography>
              </Box>
              <Box>
                <Dropdown
                  label="Collection"
                  className={styles.dropdown}
                  classDropdownLabel={styles.label}
                  classDropdownPlaceholder={styles.placeholder}
                  classDropdownValueText={styles.dropdownValueText}
                  dropdownOptionsBodyStyles={{
                    fontWeight: "300",
                    fontSize: "16px",
                  }}
                  dropdownBodyStyles={{
                    width: "100%",
                  }}
                  value={collection?.name || ""}
                  placeholder="Select"
                  // setValue={(value: any) => {
                  //   const selectedCollection = collectionsFetchOptions.find(
                  //     (option) => option.name === value
                  //   );
                  //   if (selectedCollection) {
                  //     setCollection({
                  //       id: selectedCollection?._id,
                  //       name: selectedCollection.name,
                  //     });
                  //   }
                  // }}
                  setValue={(value: any) => {
                    // If it's the same, unselect it
                    if (value === collection.name) {
                      setCollection({ id: "", name: "" });
                      return;
                    }
                    const selectedCollection = collectionsFetchOptions.find(
                      (option) => option.name === value
                    );
                    if (selectedCollection) {
                      setCollection({
                        id: selectedCollection?._id,
                        name: selectedCollection.name,
                      });
                    }
                  }}
                  options={collectionsFetchOptions.map((option) => option.name)}
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <Dropdown
                  label="Status"
                  className={styles.dropdown}
                  classDropdownLabel={styles.label}
                  classDropdownPlaceholder={styles.placeholder}
                  classDropdownValueText={styles.dropdownValueText}
                  dropdownOptionsBodyStyles={{
                    fontWeight: "300",
                    fontSize: "16px",
                  }}
                  dropdownBodyStyles={{
                    width: "100%",
                  }}
                  value={status}
                  placeholder="Select"
                  setValue={(value: any) => {
                    // If it's the same, unselect it
                    if (value === status) {
                      setStatus("");
                      return;
                    }
                    setStatus(value);
                  }}
                  options={["ACTIVE", "INACTIVE", "DRAFT"]}
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <Dropdown
                  label="Theme"
                  className={styles.dropdown}
                  classDropdownLabel={styles.label}
                  classDropdownPlaceholder={styles.placeholder}
                  classDropdownValueText={styles.dropdownValueText}
                  dropdownOptionsBodyStyles={{
                    fontWeight: "300",
                    fontSize: "16px",
                  }}
                  dropdownBodyStyles={{
                    width: "100%",
                  }}
                  value={theme || ""}
                  placeholder="Select"
                  setValue={(value: any) => {
                    // If it's the same, unselect it
                    if (value === theme) {
                      setTheme("");
                      return;
                    }
                    setTheme(value);
                  }}
                  options={["LIGHT", "DARK"]}
                />
              </Box>
            </Box>
          </Box>
          {/* Row2 */}
          <Box
            sx={{
              display: "flex",
              flex: 1,
              gap: "40px",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <TagInput
                textinputstyles={{
                  maxWidth: "430px",
                  minWidth: "100%",
                }}
                value={tags || []}
                onChange={(newTags: any) => {
                  setTags(newTags);
                }}
                label="Tags"
              />
              <Typography
                className="err_field"
                id="createProductTagsNotExist"
                color="red"
                variant="body2"
              ></Typography>
            </Box>
            <Box sx={{ flex: 1 }} className={styles.inputContainer}>
              <TextAreaInput
                style={{
                  flex: 1,
                  height: "179px",
                }}
                label="Description"
                lableStyles={{ fontSize: "16px !important" }}
                placeholder="Long product description"
                type="text"
                value={description}
                onChange={(e: any) => {
                  setDescription(e.target.value);
                }}
              />
              <Typography
                className="err_field"
                id="createProductDescNotExist"
                color="red"
                variant="body2"
              ></Typography>
            </Box>
          </Box>
          {/* Action Buttons  */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <ButtonSecondary
              sx={{
                height: "46px !important",
                width: "112px",
                background: "transparent",
              }}
              onClick={() => {
                props?.setEditMultipleComponentsDialogueVisible(false);
              }}
              LabelStyle={{
                fontSize: "18px !important",
                fontWeight: "600",
                lineHeight: "22px",
              }}
              label="Cancel"
            />
            <ButtonPrimary
              sx={{
                height: "46px !important",
                width: "112px",
                border: "1px solid #3D3D3D",
              }}
              onClick={() => {
                handleSaveEditMultipleComponents();
              }}
              isLoading={false}
              LabelStyle={{
                fontSize: "18px !important",
                fontWeight: "600",
                lineHeight: "22px",
              }}
              label="Save"
            />
          </Box>
        </Box>
      }
    />
  );
};

export default EditMulipleComponentsDialogue;

const useStyles = makeStyles((theme) =>
  createStyles({
    classDropdownHead: {
      backgroundColor: "#292929",
      minHeight: "48px",
      padding: "0px",
      // overflow:"hidden",
      borderRadius: "20px",
      border: "none",
    },
    classSelectedValueStyles: {
      border: "1px solid #3D3D3D",
      backgroundColor: "#292929",
      display: "flex",
      flexWrap: "wrap",
      overflowY: "auto",
      padding: "11px 35px 13px 20px",
      borderRadius: "12px",
    },
    classDropdownOption: {
      backgroundColor: "#292929",
      cursor: "pointer",
      borderBottom: "1px solid #292929",
      "&:hover": {
        color: "#FFFFFF",
        backgroundColor: "#505050",
      },
    },
    classDropdownBody: {
      backgroundColor: "#292929",
      boxShadow: "none",
    },
    classChipContainerStyle: {
      color: "#FFFFFF",
    },
    dropdown: {
      width: "100%",
      minWidth: "200px",
    },
    placeholder: {
      color: "#687588",
      fontSize: "14px",
      fontWeight: "500",
      fontFamily: "Inter Tight",
    },
    inputContainer: {
      flex: 1,
    },
    field: {
      // width: "100%",
      // maxWidth: "100%",
    },
    dropdownValueText: {
      color: "white",
      fontSize: "16px",
      fontWeight: "300",
    },
    label: {
      color: "#FFFFFF",
    },
  })
);
